"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _DropdownOptions = _interopRequireDefault(require("../DropdownOptions"));

var _Label = _interopRequireDefault(require("../Label"));

var _FlightsOrdersCard = _interopRequireDefault(require("./FlightsOrdersCard.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var DefaultFlightDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightsOrdersCard__DefaultFlightDetailsWrapper",
  componentId: "sc-ajwl5v-0"
})(["box-sizing:border-box;padding:", ";border:1px solid ", ";border-radius:", ";margin-top:", ";background:white;cursor:pointer;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.XXXSmall;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.micro;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.XXXSmall;
});

DefaultFlightDetailsWrapper.displayName = 'DefaultFlightDetailsWrapper';

var RowWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightsOrdersCard__RowWrapper",
  componentId: "sc-ajwl5v-1"
})(["font-size:", ";display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.normal;
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding;
});

RowWrapper.displayName = 'RowWrapper';

var Container = _styledComponents.default.div.withConfig({
  displayName: "FlightsOrdersCard__Container",
  componentId: "sc-ajwl5v-2"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";width:", ";text-align:", ";align-items:center;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.neutral;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily.default;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.medium;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.small;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.lineHeight.normal;
}, function (_ref12) {
  var width = _ref12.width;
  return width || '';
}, function (_ref13) {
  var textAlign = _ref13.textAlign;
  return textAlign || '';
});

var CardContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightsOrdersCard__CardContainer",
  componentId: "sc-ajwl5v-3"
})(["width:", ";text-align:", ";"], function (_ref14) {
  var width = _ref14.width;
  return width || '';
}, function (_ref15) {
  var textAlign = _ref15.textAlign;
  return textAlign || '';
});

Container.displayName = 'Container';

var HorizontalLine = _styledComponents.default.hr.withConfig({
  displayName: "FlightsOrdersCard__HorizontalLine",
  componentId: "sc-ajwl5v-4"
})(["background-color:", ";border-top:", ";opacity:0.3;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.greyMedium;
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.space.mini, " solid ").concat(theme.colors.greyMedium);
});

var FlightsOrdersCard = function FlightsOrdersCard(props) {
  var accessible = props.accessible,
      theme = props.theme,
      data = props.data,
      _onOptionSelect = props.onOptionSelect,
      dropdownOptionsProps = props.dropdownOptionsProps,
      translation = props.translation;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getGrayTextProps = function getGrayTextProps(fontColor) {
    return {
      accessible: accessible,
      color: fontColor || _constant.COLOR.greyDark,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      hasToggle: false,
      marginBottom: _constant.SIZE.micro,
      opacity: 1,
      tag: _constant.TAG.p,
      theme: theme
    };
  };

  var getStationTextProps = function getStationTextProps(fontColor) {
    return {
      accessible: accessible,
      display: _constant.FLEX_PROPERTIES.inlineFlex,
      hasToggle: false,
      opacity: 1,
      tag: _constant.TAG.p,
      theme: theme,
      color: fontColor || _constant.COLOR.neutral
    };
  };

  var getMain = function getMain() {
    var _columns$date, _columns$date2, _columns$bookingNumbe, _columns$bookingNumbe2, _columns$status, _columns$status2, _columns$origin, _columns$origin2, _columns$depart, _columns$depart2, _columns$destination, _columns$destination2, _columns$arrive, _columns$arrive2;

    var columns = data.columns;

    var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

    return /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(DefaultFlightDetailsWrapper, {
      onClick: function onClick(e) {
        var _e$target, _e$target2, _e$target3, _e$target4, _e$target5, _e$target6;

        if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.nodeName) !== 'svg' && (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.id) !== 'airasia-dropdown-options' && (e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.nodeName) !== 'path' && (e === null || e === void 0 || (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.nodeName) !== 'P' && (e === null || e === void 0 || (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.nodeName) !== 'LI' && (e === null || e === void 0 || (_e$target6 = e.target) === null || _e$target6 === void 0 ? void 0 : _e$target6.id) !== 'dropdown') {
          _onOptionSelect(language.general, data.actions);
        }
      }
    }, /*#__PURE__*/_react.default.createElement(RowWrapper, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Text.default, getGrayTextProps((columns === null || columns === void 0 || (_columns$date = columns.date) === null || _columns$date === void 0 ? void 0 : _columns$date.fontColor) || ''), (columns === null || columns === void 0 || (_columns$date2 = columns.date) === null || _columns$date2 === void 0 ? void 0 : _columns$date2.value) || columns.date)), /*#__PURE__*/_react.default.createElement(Container, {
      width: "50px",
      textAlign: "right",
      id: "dropdown"
    }, /*#__PURE__*/_react.default.createElement(_DropdownOptions.default, (0, _extends2.default)({}, dropdownOptionsProps, {
      data: data.dropdownData,
      onOptionSelect: function onOptionSelect(val) {
        _onOptionSelect(val, data.actions);
      }
    })))), /*#__PURE__*/_react.default.createElement(RowWrapper, {
      padding: "10px 0px"
    }, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Text.default, getGrayTextProps((columns === null || columns === void 0 || (_columns$bookingNumbe = columns.bookingNumber) === null || _columns$bookingNumbe === void 0 ? void 0 : _columns$bookingNumbe.fontColor) || ''), language === null || language === void 0 ? void 0 : language.bookingNumberMobile, " ", (columns === null || columns === void 0 || (_columns$bookingNumbe2 = columns.bookingNumber) === null || _columns$bookingNumbe2 === void 0 ? void 0 : _columns$bookingNumbe2.value) || columns.bookingNumber)), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: data.labelColour.label,
      textColor: data.labelColour.text
    }, language[(columns === null || columns === void 0 || (_columns$status = columns.status) === null || _columns$status === void 0 ? void 0 : _columns$status.text) || columns.status] || (columns === null || columns === void 0 || (_columns$status2 = columns.status) === null || _columns$status2 === void 0 ? void 0 : _columns$status2.text) || columns.status))), /*#__PURE__*/_react.default.createElement(RowWrapper, null, /*#__PURE__*/_react.default.createElement(CardContainer, {
      width: "40%"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, getStationTextProps((columns === null || columns === void 0 || (_columns$origin = columns.origin) === null || _columns$origin === void 0 ? void 0 : _columns$origin.fontColor) || ''), (columns === null || columns === void 0 || (_columns$origin2 = columns.origin) === null || _columns$origin2 === void 0 ? void 0 : _columns$origin2.value) || columns.origin)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, getGrayTextProps((columns === null || columns === void 0 || (_columns$depart = columns.depart) === null || _columns$depart === void 0 ? void 0 : _columns$depart.fontColor) || ''), (columns === null || columns === void 0 || (_columns$depart2 = columns.depart) === null || _columns$depart2 === void 0 ? void 0 : _columns$depart2.value) || columns.depart))), /*#__PURE__*/_react.default.createElement(CardContainer, {
      width: "20%",
      textAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "ArrowRightAltIcon",
      fontsize: _constant.ICON_TYPE.normal.size,
      color: _constant.ICON_TYPE.normal.color
    })), /*#__PURE__*/_react.default.createElement(CardContainer, {
      textAlign: "right",
      width: "40%"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, getStationTextProps((columns === null || columns === void 0 || (_columns$destination = columns.destination) === null || _columns$destination === void 0 ? void 0 : _columns$destination.fontColor) || ''), (columns === null || columns === void 0 || (_columns$destination2 = columns.destination) === null || _columns$destination2 === void 0 ? void 0 : _columns$destination2.value) || columns.destination)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, getGrayTextProps((columns === null || columns === void 0 || (_columns$arrive = columns.arrive) === null || _columns$arrive === void 0 ? void 0 : _columns$arrive.fontColor) || ''), (columns === null || columns === void 0 || (_columns$arrive2 = columns.arrive) === null || _columns$arrive2 === void 0 ? void 0 : _columns$arrive2.value) || columns.arrive))))), data.bottomBorder && /*#__PURE__*/_react.default.createElement(HorizontalLine, null));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

FlightsOrdersCard.propTypes = _FlightsOrdersCard.default.PropTypes;
FlightsOrdersCard.defaultProps = _FlightsOrdersCard.default.DefaultProps;
var _default = FlightsOrdersCard;
exports.default = _default;